var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { mergeProps } from 'react-aria';
import { Button } from '../button';
import { ChevronDown } from '../icon';
import { useToggleButton } from './context';
import { buttonStyle, dropdownTriggerStyle } from './styles';
function DropdownTrigger({ fullWidth, hideLabel, isDropdown, size, variant, }) {
    return isDropdown ? (_jsx("span", Object.assign({ css: dropdownTriggerStyle({
            fullWidth,
            hideLabel,
            size,
            variant,
        }) }, { children: _jsx(ChevronDown, { size: size }) }))) : null;
}
export default function ButtonInternal(_a, ref) {
    var { 'aria-label': ariaLabel, as, children, count, decor, hideLabel = false, id, isActive = false } = _a, restProps = __rest(_a, ['aria-label', "as", "children", "count", "decor", "hideLabel", "id", "isActive"]);
    const { fullWidth, hasDividers, isDropdown, onChange, size, variant } = useToggleButton();
    const typedRestProps = restProps;
    function handleClick() {
        onChange === null || onChange === void 0 ? void 0 : onChange(id);
    }
    const sharedButtonProps = {
        as,
        css: buttonStyle({
            fullWidth,
            hasDividers,
            hideLabel,
            isActive,
            isDropdown,
            size,
            variant,
        }),
        onClick: handleClick,
        ref,
        size,
    };
    return hideLabel && ariaLabel != null && decor != null ? (_jsx(Button, Object.assign({}, {
        'aria-label': ariaLabel,
        icon: isDropdown ? (_jsxs(_Fragment, { children: [decor, _jsx(DropdownTrigger, Object.assign({}, { fullWidth, hideLabel, isDropdown, size, variant }))] })) : (decor),
    }, mergeProps(typedRestProps, sharedButtonProps), { variant: "plain" }))) : (_jsx(Button, Object.assign({}, {
        'aria-label': ariaLabel,
        children,
        iconLeft: decor,
        iconRight: (_jsxs(_Fragment, { children: [count, _jsx(DropdownTrigger, Object.assign({}, { fullWidth, hideLabel, isDropdown, size, variant }))] })),
    }, mergeProps(typedRestProps, sharedButtonProps), { variant: "plain" })));
}
